import { Avatar, Stack, Typography } from '@mui/material';
import { ServerErrorIcon_1, ServerErrorIcon_2 } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IServerError {
  size?: 'small' | 'medium' | 'large';
}

export const ServerError = ({ size }: IServerError) => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.Home];

  return (
    <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant='body1' mb={1}>
        {dictionary.serverErrorMsg}
      </Typography>
      <Typography variant='body3' mb={isDesktop ? 5 : 2.5}>
        {dictionary.serverErrorMsg2}
      </Typography>
      <Avatar
        sx={{
          width: '100%',
          height: 'auto',
          mb: 2,
        }}
        src={
          isDesktop && size !== 'small' ? ServerErrorIcon_2 : ServerErrorIcon_1
        }
        alt={''}
      />
    </Stack>
  );
};
